import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BaseComponent } from '../base-component/base.component';
import { SidebarItem } from './sidebar-item.interface';
import { SidebarLogo } from './sidebar-logo.interface';
import { SidebarService } from './sidebar.service';

@Component({
  selector: 'favie-sidebar',
  templateUrl: './sidebar.component.html',
})
export class SidebarComponent extends BaseComponent {
  @Input() hideSidebarAtUrls: string[];
  @Input() logo: SidebarLogo;
  @Input() items: SidebarItem[];

  @Output() closeSidebar: EventEmitter<any> = new EventEmitter<any>();

  public isVisible = false;
  public isHide = false;

  public activeItem;
  public activeSubItem;

  private _isExpand = false;
  private _isExpandOnHover = false;

  constructor(
    public router: Router,
    private sidebarService: SidebarService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super();
  }

  get isExpand() {
    return this._isExpand || this._isExpandOnHover;
  }

  onInit() {
    this.initActiveItem();
    this.initHideAtUrls();
    this.initVisible();
    this.initExpand();
    this.initExpandOnHover();
  }

  onToggleExpand() {
    this.sidebarService.expandSidebar(!this._isExpand);
  }

  private initActiveItem() {
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        const { urlAfterRedirects = '' } = val;
        [this.activeItem, this.activeSubItem] =
          this.sidebarService.handleInitActiveSidebar(
            urlAfterRedirects,
            this.items
          );
      }
    });
    [this.activeItem, this.activeSubItem] =
      this.sidebarService.handleInitActiveSidebar(this.router.url, this.items);
  }

  private initHideAtUrls() {
    if (this.hideSidebarAtUrls) {
      this.subscribe(this.router.events, (event) => {
        if (event instanceof NavigationEnd) {
          const arr = event.url.split('/');
          const currentRoute = arr[arr.length - 1];
          this.isHide = this.hideSidebarAtUrls.includes(currentRoute);
        }
      });
    }
  }

  private initVisible() {
    this.subscribe(this.sidebarService.isSideBarVisibleObs(), (isVisible) => {
      this.isVisible = isVisible;
    });
  }

  private initExpand() {
    this.subscribe(this.sidebarService.getExpandSidebarObs(), (isExpand) => {
      this._isExpand = isExpand;
    });
  }

  private initExpandOnHover() {
    this.subscribe(
      this.sidebarService.getExpandOnHoverSidebarObs(),
      (isExpand) => {
        this._isExpandOnHover = isExpand;
      }
    );
  }

  public onMouseHoverMenu(isShowSubMenu: boolean, menu: SidebarItem) {
    if (menu.hoverToShow && !this.isCurrentLink(menu)) {
      menu.isShowSub = isShowSubMenu;
    }
  }

  public isCurrentLink(item: SidebarItem): boolean {
    return this.router.url.includes(item.routerLink);
  }

  public isCurrentDetailLink(item: SidebarItem): boolean {
    return (
      this.router.url.includes(item.routerLink) &&
      this.router.url.includes('/detail')
    );
  }

  public clickWithoutSubMenu() {
    const menuHadSub = this.items.filter((item) => item.isHadSub);
    if (menuHadSub?.length) {
      menuHadSub.forEach((element) => {
        if (element.hoverToShow) {
          element.isShowSub = false;
        }
      });
    }
  }
}
